<template>
  <div class="col col-lg-3">
    <div class="input-group">
      <label for="tipoDocumentoField">
        Tipo de Documento
        <span class="recent-updated-label" v-if="recentUpdatedField">
          <tooltip-informacao-alterada />
        </span>
        <select
          :disabled="disabled"
          id="tipoDocumentoField"
          v-model="model.content"
          class="form-select"
          :class="{
            'recent-updated': recentUpdatedField,
          }"
        >
          <option
            v-for="(documento, documentoIndex) in list"
            :key="`tipo_documento_${documentoIndex}`"
            :value="documento"
          >
            {{ documento.nome }}
          </option>
        </select>
        <div class="form-text">Escolha uma das opções.</div>
      </label>
    </div>
  </div>
</template>

<script>
import ContatoService from "@/services/portal/empresa/ContatoService";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
import FieldTemplateUpperCase from "@/components/forms/fields/empresa/FieldTemplateUpperCase.vue";
export default {
  extends: FieldTemplateUpperCase,
  props: {
    disabled: Boolean,
    modelProp: Object,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      list: new Array(),
      loadList: undefined,
      model: {
        name: "documento",
        content: "",
      },
    };
  },
  mounted() {
    this.loadList = ContatoService.listTipoDocumento()
      .then(
        ({ data }) => (this.list = data.filter((documento) => documento.ativo))
      )
      .catch((error) => console.log(error));
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}
</style>
